/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { selectAuthUserData } from '../../redux/features/auth/auth.slice';
import { isRoleValid } from '../../redux/features/auth/auth.helper';

// TODO: this whole file needs some love. TBD Refactor according to the new RoutePath structure
export function IsInRole({ children, roles = [] }) {
  const userData = useSelector(selectAuthUserData);
  const authorized = isRoleValid(userData?.roles, roles);
  return <>{authorized && children}</>;
}
